<template>
  <div>
    <Navbar type="bg-transparent-sticky" />
    <div class="hero-container-thin">
      <div class="hero-opacity" />
      <img class="hero-image" src="../assets/gdq_hero.jpg" alt="hero image" />
    </div>
    <Breadcrumb />
    <div class="container-xl" style="position:relative !important;">
      <!-- Loading Overlay -->
      <div v-if="loading" class="loading-overlay d-flex justify-content-center mb-3">
        <div class="spinner-border" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
      <div class="text-container">
        <div class="title-area">
            <h1 class="page-title">
                <span
                  :class="`${anon ? 'g-anon' : '' }`"
                >
                  {{ survey.survey_name }}:
                </span>
                {{ screentexts[154]?screentexts[154].element_text:'Invitation' }}
                <!-- <PopupBubble
                  v-if="screentexts[154] && screentexts[154].element_bubbletext != '' && screentexts[154].element_bubbletext !== null"
                  screenelement_id="154"
                  :screen_id="screen_id"
                  :bubbletext="screentexts[154]?screentexts[154].element_bubbletext:''"
                /> -->
            </h1>
        </div>
        <div class="form-group mb-4">
          <label>
            {{ screentexts[157]?screentexts[157].element_text:'Invitation e-mail Subject Line' }}
          </label>
          <input
            type="text"
            class="form-control"
            v-model="survey.survey_invitation_subject"
            :placeholder="screentexts[158]?screentexts[158].element_text:'Enter the subject of the invitation e-mail'"
          />
        </div>
        <div
          v-if="survey.spotify!=1"
          class="form-group mb-4"
        >
          <label>
            {{ screentexts[155]?screentexts[155].element_text:'Invitation e-mail fixed text' }}
          </label>
          <div
            id="fixed-text"
            class="mt-3"
            v-html="survey.survey_invitation_text"
          />
        </div>
        <div class="d-flex justify-content-end mb-4">
          <button @click="copyText" type="button" class="btn btn-secondary btn-small">
            Copy Text
          </button>
        </div>
        <div class="form-group mb-4">
          <label>
            {{ screentexts[156]?screentexts[156].element_text:'Invitation e-mail personal text' }}
          </label>
          <BaseEditor
            v-model="survey.survey_invitation_consultant_text"
            :class="`${anon ? 'g-anon' : '' }`"
            :editor-toolbar="editortoolbar"
            :placeholder="'Personal text'"
          />
        </div>
        <div class="buttons-navigation mt-5">
          <router-link
            to="/create/group/survey/details"
            class="btn btn-secondary float-left"
          >
            &lt; Back
          </router-link>
          <router-link
            to="/create/group/survey/dates"
            class="float-right"
          >
            <button class="btn btn-primary" type="button">
              Next >
            </button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Navbar from './Navbar.vue'
import Breadcrumb from './Breadcrumb.vue'
import BaseEditor from './base/BaseEditor.vue'

const editortools = [
  []
]

export default {
  name: 'CreateGroupSurveyEmailSettings',
  components: {
    Navbar,
    Breadcrumb,
    BaseEditor
  },
  data () {
    return {
      editortoolbar: editortools,
      group_name: this.$store.state.currentgroup.group_name,
      survey: this.$store.state.currentsurvey,
      screen_id: 10,
      screentexts: [],
      loading: false
    }
  },
  computed: {
    anon: function () {
      return this.$store.state.anon
    },
    survey_id () {
      return this.$store.state.currentsurvey_id
    }
  },
  async created () {
    this.loading = true
    await this.screentexts_get()
    await this.survey_get()
    this.loading = false
  },
  async beforeRouteLeave (to, from, next) {
    // ---------------------------------------------------------------------------
    // We are going forward - save, I wonder should I change "create" to "save" ?
    // ---------------------------------------------------------------------------
    if (to.name === 'creategroupsurveydates') {
      await this.groupsurvey_save()
    }
    next()
  },
  methods: {
    parse_email (email) {
      // eslint-disable-next-line
      const pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;   
      return pattern.test(email.toLowerCase())
    },
    survey_get: async function () {
      await this.$store.dispatch('groupsurvey_fetch', { id: this.survey_id })
        .then((resp) => {
          this.survey = resp.data
        })
    },
    screentexts_get: async function () {
      const screentexts = []
      const filter = {
        screen_id: {
          operator: '=',
          value: this.screen_id
        }
      }
      await this.$store.dispatch('systemscreenelements_fetch', { filter })
        .then((resp) => {
          const dbtexts = resp.data.result
          for (let i = 0; i < dbtexts.length; i++) {
            const screentext = {
              id: dbtexts[i].id,
              element_text: dbtexts[i].element_text,
              element_bubbletext: dbtexts[i].element_bubbletext
            }
            screentexts[dbtexts[i].id] = screentext
          }
          this.screentexts = screentexts
        })
    },
    copyText () {
      const editorContent = document.querySelector('#fixed-text')
      const range = document.createRange()
      range.selectNodeContents(editorContent)
      const selection = window.getSelection()
      selection.removeAllRanges()
      selection.addRange(range)
      document.execCommand('copy')
      selection.removeAllRanges()
    },
    async groupsurvey_save () {
      // this.survey.survey_invitation_subject = this.survey.survey_invitation_subject
      // this.survey.survey_invitation_text = this.survey.survey_invitation_text
      // this.survey.survey_invitation_consultant_text = this.survey.survey_invitation_consultant_text
      //      survey.survey_invitation_cc = this.survey_invitation_cc;
      await this.$store.dispatch('groupsurvey_save', { survey: this.survey })
    }
  }
}
</script>
<style scoped>
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8); /* Semi-transparent background */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
</style>
